const Menuitems = [
  {
    navlabel: true,
    subheader: 'Main',
    icon: 'mdi mdi-dots-horizontal',
    href: 'Dashboard',
  },
  {
    title: 'Dashboard',
    icon: 'user',
    href: '/app',
  },
  {
    title: 'Editor',
    icon: 'edit',
    href: '/app/editor',
  },
  {
    title: 'Catalog',
    icon: 'list',
    href: "/app/catalog"
  }
];

export default Menuitems;
